/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 154.0.0-SNAPSHOT
 */

export type SalesPartnerCreateCustomerLanguageEnum =
  (typeof SalesPartnerCreateCustomerLanguageEnum)[keyof typeof SalesPartnerCreateCustomerLanguageEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SalesPartnerCreateCustomerLanguageEnum = {
  DE: "DE",
  EN: "EN",
  FR: "FR",
} as const;
